<template>
  <!--弹窗-->
    <el-dialog width="700px" :title="title" :visible.sync="visible" :before-close="handleClose" top="10vh">
        <el-form ref="formData" :model="list" label-width="140px" :rules="rules">
            <el-form-item label="充值金额：" prop="amount">
                <el-input v-model="list.amount" style="width: 200px;margin-right:20px;" placeholder="请输入充值金额" @keyup.enter.native="submitForm('formData')"></el-input>
            </el-form-item>
            <el-form-item label="充值货币：" prop="currency"> 
                <el-select v-model="list.currency" placeholder="选择充值货币" disabled>
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上传凭证：">
                <el-upload
                    v-show="!list.image"
                    class="upload-demo"
                    drag
                    action="/"
                    accept="image/png, image/jpeg"
                    :http-request="httpRequest"
                    :show-file-list="false">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__text" style="font-size: 12px;">只能上传.png/.jpg文件</div>
                </el-upload>
                <div v-show="list.image" style="display: inline-block;position: relative;margin-right: 30px;" @click="delimg()">
                    <img class="img" :src="list.image" alt="" >
                    <div class="img-cha">×</div>
                </div>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(true)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/user/payorders";
export default {
    data() {
        return {
            loading: false,
            roles: [
                {
                    id: "CNY",
                    name: "人民币"
                },
                {
                    id: "USD",
                    name: "美金"
                }
            ],
            list: {
                currency: "CNY",
                image: ""
            },
            rules: {
                amount: [
                    {
                        required: true,
                        message: "请输入充值金额",
                        trigger: "blur"
                    }
                ],
                currency: [
                    {
                        required: true,
                        message: "选择充值货币",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    if (
                        Number(this.list.amount) < 0 ||
                        Number(this.list.amount) == 0
                    ) {
                        this.$message({
                            type: "error",
                            message: "请输入大于0的金额"
                        });
                        return;
                    }
                    if (!this.list.image) {
                        this.$message({
                            type: "error",
                            message: "请上传支付凭证"
                        });
                        return;
                    }
                    this.loading = true;
                    this.list.admin_id = this.formData.id;
                    api.charge_index(this.list)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 关闭窗口, 刷新列表
                                this.$message({
                                    message: "充值成功",
                                    type: "success"
                                });
                                this.handleClose(false);
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.$message({
                                message:
                                    "网络出现问题，请刷新页面查看是否充值成功！",
                                type: "error"
                            });
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        //删除上传的图片
        delimg() {
            this.$confirm(`确定要删图片吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.list.image = "";
                })
                .catch(() => {});
        },
        //上传图片转bese64
        httpRequest(options) {
            var that = this;
            let file = options.file;
            if (
                file.type == "image/jpeg" ||
                file.type == "image/png" ||
                file.type == "image/JPG"
            ) {
                var isJPG = true;
            } else {
                isJPG = false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
                this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
                return;
            }
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 2MB!");
                return;
            }
            if (this.list.image) {
                this.$message.error("上传图片不能超过1张");
                return;
            }
            var reader = new FileReader();
            var img = new Image();
            if (file) {
                reader.readAsDataURL(file);
            }
            if (isJPG && isLt2M) {
                reader.onload = e => {
                    img.src = e.target.result;
                    img.onload = function() {
                        var canvas = document.createElement("canvas");
                        var context = canvas.getContext("2d");
                        var originWidth = this.width;
                        var originHeight = this.height;
                        var targetWidth = originWidth,
                            targetHeight = originHeight;
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;
                        context.clearRect(0, 0, targetWidth, targetHeight);
                        context.drawImage(img, 0, 0, targetWidth, targetHeight);
                        var newUrl = canvas.toDataURL("image/jpeg", 0.92);
                        that.list.image = newUrl;
                    };
                };
            }
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.list = {
                currency: "CNY",
                image: ""
            };
            this.$emit("close-callback", isshow);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
.img {
    width: 400px;
    border: 1px rgb(206, 202, 202) solid;
}
.img-cha {
    position: absolute;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    top: 0;
    right: 0;
    font-size: 20px;
}
</style>
